var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94188 0.393985C9.27657 0.638029 9.35005 1.10718 9.10601 1.44187L4.73101 7.44187C4.60267 7.61788 4.40414 7.7294 4.18706 7.74742C3.96997 7.76544 3.75578 7.68819 3.60017 7.53576L0.975165 4.96433C0.679268 4.67447 0.674373 4.19962 0.964231 3.90373C1.25409 3.60783 1.72894 3.60294 2.02484 3.89279L4.03011 5.85715L7.89399 0.558112C8.13804 0.223424 8.60719 0.149942 8.94188 0.393985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tick-mark.03bd697dc081e2a22a2e3f60957cb663.svg";
export { ForwardRef as ReactComponent };